import {storageData} from "@/assets/js/storage";

export function routerJump() {
  const userInfo = storageData.getUserInfo();
  let path = "";
  switch (userInfo.member_type) {
    case "super":
    case "system":
      path = "/system/sm";
      break;
    case "organ":
      path = "/organization/training_course_manager";
      break;
    case "teacher":
      path = "/teacher/class";
      break;
    case "student":
      path = "/student/class_detail";
      break;
    case "registration":
      path = "/registrationList";
      break;
    case "expireStudent":
      path = "/expireStudent/tran_his";
      break;
  }
  return path;
}
export function evaluationJump() {
  const userInfo = storageData.getUserInfo();
  let path = "";
  switch (userInfo.member_type) {
    case "organ":
      path = "/organization/evaluation_list";
      break;
    case "teacher":
      path = "/teacher/evaluation_list";
      break;
    case "student":
      path = "/student/create_evaluation";
      break;
  }
  return path;
}